/* ============================================================
   cro-configurator.js — Diinsign Hero-Konfigurator v3 (Globo-Ersatz)
   State, Live-Name-Vorschau (Panorama), Live-Preis, conditional sub_options,
   Bestandskopplung, bebilderte Auswahlen, Symbol-SVG-Icons, HEX-Swatches, Cart-Add.
   v3: Quran+Lataffa als Toggle (AUS->Property "Kein..."; AN->Add-on-Zeile),
       Name DIREKT unter Panorama-Vorschau, dann Farbe; USP-Sektion; promo-Mechanik.
   Cart-Payload byte-genau Globo-kompatibel (Properties + Add-on-Zeilen). NICHT brechen.
   ============================================================ */
(function () {
  'use strict';

  var HAS_GPO = '1452280';            // Globo-Marker (aus echten Orders)
  var NAME_ADDON = '52889431179530';  // Personalisierungstext-Add-on

  // Inline-SVG-Icons fuer Zubehoer-Thumbnails (DSGVO: kein externer Request, rendern garantiert).
  // Modul-Scope, damit accThumb() schon beim ersten init-Render zuverlaessig darauf zugreift.
  var ACC_ICONS = {
    // Geschenkschleife — Schachtel mit Schleife
    bow: '<rect x="4" y="11" width="40" height="31" rx="3" fill="#fff" stroke="#b8902f" stroke-width="2.4"/>' +
         '<path d="M4 20h40" stroke="#b8902f" stroke-width="2.4"/>' +
         '<path d="M24 11v31" stroke="#b8902f" stroke-width="2.4"/>' +
         '<path d="M24 11c-4-5-11-7-11-11a4.5 4.5 0 0 1 11 2" fill="#f1d6ab" stroke="#b8902f" stroke-width="2.2" stroke-linejoin="round"/>' +
         '<path d="M24 11c4-5 11-7 11-11a4.5 4.5 0 0 0-11 2" fill="#f1d6ab" stroke="#b8902f" stroke-width="2.2" stroke-linejoin="round"/>',
    gift: '<rect x="6" y="18" width="36" height="24" rx="2" fill="#fff" stroke="#b8902f" stroke-width="2.4"/>' +
          '<path d="M6 26h36M24 18v24" stroke="#b8902f" stroke-width="2.4"/>' +
          '<path d="M24 18c-3-4-9-5-9-9a3.5 3.5 0 0 1 9 1.5c0-4 6-5.5 9-1.5a3.5 3.5 0 0 1-9 9z" fill="#f1d6ab" stroke="#b8902f" stroke-width="2"/>'
  };

  // ============================================================
  // i18n v3.10 — UI-Strings extern (window.diiConfiguratorI18n, vom Liquid je Shopify-Locale
  // gerendert). KEIN harter Text mehr im JS: jeder diiT()/diiTf()-Aufruf traegt die DE-Vorlage
  // als Fallback -> fehlt das I18n-Objekt, ist das Verhalten byte-identisch zu vorher (kein Bruch).
  // WICHTIG: NUR Anzeige-Strings sind uebersetzbar. Globo-Property-WERTE (Cart/Fulfillment) bleiben
  // byte-genau DE/kanonisch (diiCanon) — Uebersetzung betrifft ausschliesslich das, was der Kunde SIEHT.
  // ============================================================
  var DII_I18N = (typeof window !== 'undefined' && window.diiConfiguratorI18n) ? window.diiConfiguratorI18n : {};
  var DII_LOC = (function () {
    var l = (typeof window !== 'undefined' && window.Shopify && window.Shopify.locale) ||
            (document.documentElement && document.documentElement.lang) || 'de';
    return String(l).toLowerCase().split('-')[0]; // "de-DE" -> "de"
  })();
  // Owner-Entscheidung 2026-06-30: Stickerei stickt links-nach-rechts, KEIN RTL (auch fuer Arabisch).
  // Daher RTL-UI-Flip global aus; arabische Namen werden im Noto-Sans-Arabic-Font LTR angezeigt.
  var DII_RTL = false;

  // UI-String holen (key -> uebersetzt; sonst DE-Fallback).
  function diiT(key, fallback) {
    var v = DII_I18N[key];
    return (v != null && v !== '') ? v : fallback;
  }
  // UI-String mit Platzhaltern {name} interpolieren.
  function diiTf(key, fallback, vars) {
    return String(diiT(key, fallback)).replace(/\{(\w+)\}/g, function (_, k) {
      return (vars && vars[k] != null) ? vars[k] : '';
    });
  }
  // Lokalisierbares LABEL aus der Config: entweder String (DE) ODER { de, nl, fr, tr, ar }.
  //  diiPick  = ANZEIGE (aktuelle Locale, DE-Fallback) — nur fuer das, was der Kunde sieht.
  //  diiCanon = KANONISCHER Wert fuer Cart-Property/Fulfillment — IMMER DE (byte-genau), nie uebersetzt.
  // Bei reinen Strings (heutiger Datenstand) liefern beide den String unveraendert -> kein Bruch.
  function diiPick(o) {
    if (o && typeof o === 'object' && !Array.isArray(o)) {
      return (o[DII_LOC] != null && o[DII_LOC] !== '') ? o[DII_LOC] : (o.de != null ? o.de : '');
    }
    return o == null ? '' : o;
  }
  function diiCanon(o) {
    if (o && typeof o === 'object' && !Array.isArray(o)) return o.de != null ? o.de : diiPick(o);
    return o == null ? '' : o;
  }

  document.querySelectorAll('[data-dii-config]').forEach(initConfigurator);

  function initConfigurator(root) {
    if (root.__diiInit) return;
    root.__diiInit = true;

    // i18n/RTL am Wurzelelement verankern (CSS-Scoping fuer [dir="rtl"] / [lang="ar"]-Stickfont).
    // Liquid setzt diese Attribute serverseitig schon; hier als Absicherung, falls die Locale
    // erst clientseitig (Shopify.locale) feststeht.
    if (DII_LOC && root.getAttribute('lang') !== DII_LOC) root.setAttribute('lang', DII_LOC);
    if (DII_RTL) root.setAttribute('dir', 'rtl');

    var cfg, variants;
    try {
      cfg = JSON.parse(root.querySelector('[data-dii-cfg]').textContent);
      if (typeof cfg === 'string') cfg = JSON.parse(cfg); // doppelt kodiert (| json auf string)
    } catch (e) { console.error('[dii-config] cfg parse fail', e); return; }
    try {
      variants = JSON.parse(root.querySelector('[data-dii-variants]').textContent);
    } catch (e) { variants = []; }

    // ROBUSTHEIT v3.2: Live-Verfuegbarkeit der Upsell-/Add-on-Varianten (aus Liquid all_products).
    // Fehlende ID -> als verfuegbar behandeln (kein Fehlalarm); explizit false -> sperren/ausblenden.
    var addonAvail = {};
    try {
      var aaEl = root.querySelector('[data-dii-addon-avail]');
      if (aaEl) addonAvail = JSON.parse(aaEl.textContent) || {};
    } catch (e) { addonAvail = {}; }
    function addonAvailable(vid) {
      if (!vid || vid === 'None' || vid === 'null') return false;
      var k = String(vid);
      return addonAvail[k] === false ? false : true; // unbekannt -> verfuegbar
    }

    var variantById = {};
    variants.forEach(function (v) { variantById[String(v.id)] = v; });

    // ---- Farb-MAP aus Config (Optik: swatch_bg / image / compare_at) per Farbname (label) ----
    // normalisiert (lowercase, getrimmt, "Gruen"<->"Grün" toleriert) -> robust gegen Umlaut-Drift.
    function normColor(s) {
      return String(s == null ? '' : s).toLowerCase().trim()
        .replace(/ß/g, 'ss').replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue')
        .replace(/\(.*?\)/g, '').replace(/\s+/g, ' ').trim();
    }
    var colorMap = {};
    (cfg.colors || []).forEach(function (c) {
      colorMap[normColor(c.label)] = c;
      if (c.variant_id) colorMap['#vid:' + String(c.variant_id)] = c;
    });

    // ---- State ----
    var state = {
      colorId: null,
      qty: 1,
      core: {},       // groupKey -> {value, surcharge, addon_variant}
      accessory: {}   // groupKey -> {on, value, surcharge, addon_variant, subs:{globo_key:value}}
    };

    var allGroups  = (cfg.groups || []);

    // ROBUSTHEIT v3.7: Cross-Sell-Gruppen (quran/lataffa …) VOLL DYNAMISCH aus Live-Shopify.
    // "Voll automatisch": jede LIEFERBARE Variante der verknuepften Produkte = eine Option.
    // Bild/Preis/Verfuegbarkeit live; ausverkauft faellt raus; neue Variante erscheint automatisch.
    // Byte-sicher: gebaute Werte haben dieselbe Form (label/surcharge/addon_variant/addon_handle/image)
    // wie die statischen -> Render/availableValues/Cart-Logik bleiben unveraendert.
    var dynPool = {};
    try {
      var dpEl = root.querySelector('[data-dii-dynamic]');
      if (dpEl) dynPool = JSON.parse(dpEl.textContent) || {};
    } catch (e) { dynPool = {}; }
    allGroups.forEach(function (g) {
      if (!g || !g.dynamic) return;
      var keep = (g.values && g.values[0] && !g.values[0].addon_variant) ? g.values[0] : null; // "Kein …"-Eintrag erhalten
      var list = (dynPool[g.key] || []).filter(Boolean); // flache Liste lieferbarer Varianten (Liquid-gefiltert), null-Sentinel raus
      list.sort(function (a, b) { return (Number(b.inv) || 0) - (Number(a.inv) || 0); }); // Bestand absteigend → Slider: groesster Stock zuerst
      var built = keep ? [keep] : [];
      list.forEach(function (v) {
        built.push({
          label: v.label,
          surcharge: Number(v.price) / 100,
          addon_variant: String(v.id),
          addon_handle: v.handle || null,
          image: v.image || null
        });
      });
      // Nur ersetzen, wenn der Live-Pool echte Optionen lieferte (sonst statische Config als Fallback).
      if (built.length > (keep ? 1 : 0)) g.values = built;
    });

    // v3.7 LIVE-PREIS fuer ALLE Addon-Varianten (auch Nicht-Listen: Symbol/Parfuem/Schleife/Gebetskette/Name).
    // surcharge wird aus dem live Shopify-Preis ueberschrieben; Label/SVG/Bild/Struktur bleiben kuratiert.
    // Fehlt eine vid in der Map (Handle nicht aufloesbar) -> Config-Aufpreis bleibt (price_audit-garantiert).
    var priceMap = {};
    try {
      var pmEl = root.querySelector('[data-dii-addon-price]');
      if (pmEl) priceMap = JSON.parse(pmEl.textContent) || {};
    } catch (e) { priceMap = {}; }
    function applyLivePrice(v) {
      if (v && v.addon_variant != null && priceMap[String(v.addon_variant)] != null) {
        v.surcharge = Number(priceMap[String(v.addon_variant)]) / 100;
      }
    }
    allGroups.forEach(function (g) {
      if (g && g.addon_variant != null && priceMap[String(g.addon_variant)] != null) {
        g.surcharge = Number(priceMap[String(g.addon_variant)]) / 100; // Toggle-Aufpreis (Schleife/Gebetskette/Parfuem)
      }
      (g.values || []).forEach(applyLivePrice);
      (g.sub_options || []).forEach(function (so) { (so.values || []).forEach(applyLivePrice); });
    });

    // ROBUSTHEIT v3.2: Farben DYNAMISCH aus den Live-Varianten bauen — NICHT aus der statischen
    // Config-Liste. Jede Live-Variante = eine Farbe. Optik (swatch_bg/image/compare_at) kommt aus
    // der Config-MAP per Farbname; unbekannte Farben bekommen einen neutralen Fallback-Swatch
    // (Varianten-Bild oder grau) und werden NIE ausgeblendet. Ausverkaufte werden gesperrt.
    var allColors = buildLiveColors();
    function buildLiveColors() {
      var out = [];
      variants.forEach(function (v) {
        var label = (v.color != null && String(v.color).trim()) ? String(v.color) : String(v.title || '');
        var mapped = colorMap[normColor(label)] || colorMap['#vid:' + String(v.id)] || {};
        var hex = (mapped.swatch_bg && /^#[0-9a-fA-F]{3,8}$/.test(mapped.swatch_bg)) ? mapped.swatch_bg : null;
        // Streichpreis: bevorzugt Live-compare_at der Variante, sonst Config-Wert.
        var cmp = (v.compare_at != null && Number(v.compare_at) > 0) ? Number(v.compare_at) / 100
                : (mapped.compare_at != null ? Number(mapped.compare_at) : null);
        out.push({
          variant_id: String(v.id),
          label: label,
          price: Number(v.price) / 100,
          compare_at: cmp,
          swatch_bg: hex,                 // null -> Fallback (Bild/grau) im Render
          image: mapped.image || null,
          available: !!v.available,
          dead: false
        });
      });
      return out;
    }
    var coreGroups = allGroups.filter(function (g) { return g.category === 'kern'; });
    var accGroups  = allGroups.filter(function (g) { return g.category === 'zubehoer'; });

    // Fallback-Bild aus Config (NICHT mehr als Vorschau-Hintergrund genutzt — Farbe hat Vorrang).
    var previewImage = cfg.preview_image || '';

    var els = {
      previewWrap: root.querySelector('[data-dii-preview]'),
      preview: root.querySelector('[data-dii-preview-img]'),
      previewName: root.querySelector('[data-dii-preview-name]'),
      previewHint: root.querySelector('[data-dii-preview-hint]'),
      previewCap: root.querySelector('[data-dii-preview-cap]'),
      social: root.querySelector('[data-dii-social]'),
      stars: root.querySelector('[data-dii-stars]'),
      rating: root.querySelector('[data-dii-rating]'),
      count: root.querySelector('[data-dii-count]'),
      badges: root.querySelector('[data-dii-badges]'),
      usps: root.querySelector('[data-dii-usps]'),
      promo: root.querySelector('[data-dii-promo]'),
      promoTag: root.querySelector('[data-dii-promo-tag]'),
      promoText: root.querySelector('[data-dii-promo-text]'),
      core: root.querySelector('[data-dii-core]'),
      accHead: root.querySelector('[data-dii-accessory-head]'),
      acc: root.querySelector('[data-dii-accessory]'),
      total: root.querySelector('[data-dii-total]'),
      atc: root.querySelector('[data-dii-atc]'),
      atcLabel: root.querySelector('[data-dii-atc-label]'),
      progressBar: root.querySelector('[data-dii-progress-bar]'),
      progressLabel: root.querySelector('[data-dii-progress-label]'),
      deliver: root.querySelector('[data-dii-deliver]'),
      sticky: root.querySelector('[data-dii-sticky]'),
      peek: root.querySelector('[data-dii-peek]'),
      summary: root.querySelector('[data-dii-summary]')
    };

    // Default-Textfarbe-Hex fuer das Gold-Script-Overlay (Schritt "textcolor").
    var textColorHex = '#C5A059';
    // Aktuelle Teppich-Farbe (swatch_bg) = Vorschau-Hintergrund. Steuert auch den Lesbarkeits-Halo.
    var bgColorHex = '#d8c3a6';

    // Default Farbe = erste verfuegbare
    var firstColor = allColors.find(function (c) { return isColorAvailable(c); });
    if (firstColor) selectColor(firstColor.variant_id, true);

    renderSocial();
    renderBadges();
    renderUsps();
    renderPromo();
    renderCore();
    renderAccessory();
    renderDelivery();
    updatePreview();
    updatePriceBlock();
    updateTotal();
    updateProgress();

    els.atc.addEventListener('click', onAddToCart);

    // Chevron-Peek -> aktuelle Auswahl (readonly Text) ein-/ausblenden.
    if (els.peek && els.summary) {
      els.peek.addEventListener('click', function () {
        var willOpen = els.summary.hidden;
        if (willOpen) renderSummary();
        els.summary.hidden = !willOpen;
        els.peek.setAttribute('aria-expanded', String(willOpen));
      });
    }
    // Floating-Bar ueber bodennahe Chat-/App-Widgets heben (robust gemessen, Apps laden spaet).
    liftAboveChat();
    window.addEventListener('resize', liftAboveChat);
    var _liftN = 0, _liftIv = setInterval(function () { liftAboveChat(); if (++_liftN >= 8) clearInterval(_liftIv); }, 1200);

    // Misst bodennah fixierte Fremd-Elemente (Chat-Bubble, Abandonment-Bar) und hebt die
    // Floating-Bar per --dii-chat-lift knapp darueber. Eigene Elemente + Cookie-Banner ignoriert.
    function liftAboveChat() {
      if (!els.sticky) return;
      var vh = window.innerHeight, lift = 0;
      var nodes = document.body ? document.body.querySelectorAll('*') : [];
      for (var i = 0; i < nodes.length; i++) {
        var el = nodes[i];
        if (el === els.sticky || els.sticky.contains(el) || el.closest('.dii-config')) continue;
        var s = window.getComputedStyle(el);
        if (s.position !== 'fixed' && s.position !== 'sticky') continue;
        if (s.visibility === 'hidden' || s.display === 'none' || parseFloat(s.opacity || '1') < 0.05) continue;
        var r = el.getBoundingClientRect();
        if (r.width < 24 || r.height < 24 || r.height > vh * 0.45) continue;
        if (r.bottom < vh - 6 || r.top > vh) continue;          // nur was am unteren Rand klebt
        var id = ((el.id || '') + ' ' + (el.className || '')).toLowerCase();
        if (/cookie|consent|gdpr|pandectes|preview-bar|pbar/.test(id)) continue;  // Banner/Preview ignorieren
        var occupies = vh - r.top;                               // wie weit ragt es von unten hoch
        if (occupies > lift) lift = occupies;
      }
      lift = Math.max(0, Math.min(lift ? lift + 10 : 0, 110));   // Sicherheits-Cap
      els.sticky.style.setProperty('--dii-chat-lift', lift + 'px');
    }

    // Aktuelle Auswahl als readonly Übersicht rendern (Farbe, Kern, Zubehör, Gesamt).
    function renderSummary() {
      if (!els.summary) return;
      var rows = [];
      var c = currentColor();
      if (c) rows.push([diiT('summary_product', 'Gebetsteppich'), c.label, 0]);
      coreGroups.forEach(function (g) {
        var s = state.core[g.key];
        if (!s) return;
        if (g.type === 'text') { if (s.value && s.value.trim()) rows.push([diiPick(g.label), '„' + s.value + '“', s.surcharge || 0]); }
        else rows.push([diiPick(g.label), s.value, s.surcharge || 0]);
      });
      accGroups.forEach(function (g) {
        var a = state.accessory[g.key];
        if (!a) return;
        if (g.type === 'toggle') {
          if (a.on) {
            var subs = [];
            (g.sub_options || []).forEach(function (so) { if (a.subs && a.subs[so.globo_key]) subs.push(a.subs[so.globo_key]); });
            rows.push([accLabel(g), diiT('summary_yes', 'Ja') + (subs.length ? ' · ' + subs.join(', ') : ''), a.surcharge || 0]);
          }
        } else if (a.addon_variant && a.addon_variant !== 'None' && a.addon_variant !== 'null') {
          rows.push([accLabel(g), a.value, a.surcharge || 0]);
        }
      });
      var html = '';
      rows.forEach(function (r) {
        var sur = r[2] > 0 ? '<span class="dii-summary__sur">+ ' + fmtNum(r[2]) + ' €</span>' : '';
        html += '<div class="dii-summary__row"><span class="dii-summary__k">' + esc(r[0]) +
                '</span><span class="dii-summary__v">' + esc(String(r[1])) + sur + '</span></div>';
      });
      if (!rows.length) html = '<p class="dii-summary__empty">' + esc(diiT('summary_empty', 'Noch nichts ausgewählt.')) + '</p>';
      html += '<div class="dii-summary__row dii-summary__total"><span class="dii-summary__k">' + esc(diiT('summary_total', 'Gesamt')) + '</span>' +
              '<span class="dii-summary__v">' + fmtMoney(computeTotal()) + '</span></div>';
      els.summary.innerHTML = html;
    }

    // Voraussichtliche Lieferung: heute + 1–3 Werktage als konkretes Datum (Wochenenden uebersprungen).
    function renderDelivery() {
      if (!els.deliver) return;
      // Wochentag-/Monatsnamen lokalisiert ueber Intl (kein eigener Uebersetzungs-Datensatz noetig;
      // ar liefert arabische Namen). Fallback auf 'de' falls die Locale nicht unterstuetzt wird.
      var wdFmt, moFmt;
      try { wdFmt = new Intl.DateTimeFormat(DII_LOC || 'de', { weekday: 'short' }); }
      catch (e) { wdFmt = new Intl.DateTimeFormat('de', { weekday: 'short' }); }
      try { moFmt = new Intl.DateTimeFormat(DII_LOC || 'de', { month: 'long' }); }
      catch (e) { moFmt = new Intl.DateTimeFormat('de', { month: 'long' }); }
      function addBiz(start, days) {
        var d = new Date(start.getTime());
        var added = 0;
        while (added < days) {
          d.setDate(d.getDate() + 1);
          var wd = d.getDay();
          if (wd !== 0 && wd !== 6) added++;
        }
        return d;
      }
      var now = new Date();
      var from = addBiz(now, 1), to = addBiz(now, 3);
      function fmt(d, withMonth) {
        return wdFmt.format(d) + ', ' + d.getDate() + '.' + (withMonth ? ' ' + moFmt.format(d) : '');
      }
      var sameMonth = from.getMonth() === to.getMonth();
      var txt = fmt(from, !sameMonth) + ' – ' + fmt(to, true);
      els.deliver.innerHTML =
        '<svg class="dii-deliver__ic" viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">' +
        '<path d="M3 7h11v9H3zM14 10h4l3 3v3h-7zM7 19a2 2 0 1 0 0-.01M17.5 19a2 2 0 1 0 0-.01"/></svg>' +
        '<span><strong>' + esc(diiT('delivery_label', 'Voraussichtliche Lieferung:')) + '</strong> ' + esc(txt) + '</span>';
    }

    // ===================== Above-the-fold: Sterne / Badges / Promo =====================
    function renderSocial() {
      if (!els.social) return;
      var rev = cfg.reviews || {};
      var rating = parseFloat(root.dataset.revRating || rev.rating || 0);
      var count = root.dataset.revCount || rev.count || '';
      if (!rating) return;
      // 5 Sterne, anteilig gefuellt (echte Zahl, kein Aufrunden)
      var html = '';
      for (var i = 1; i <= 5; i++) {
        var fill = Math.max(0, Math.min(1, rating - (i - 1))) * 100;
        html += '<span class="dii-star"><span class="dii-star__fill" style="width:' + fill + '%"></span></span>';
      }
      els.stars.innerHTML = html;
      els.rating.textContent = String(rating).replace('.', ',') + ' ★';
      if (count) els.count.textContent = '· ' + diiTf('reviews_count', '{count} Bewertungen', { count: count });
      // Optionaler Familien-Text aus Config
      if (rev.customers_text) {
        var fam = document.createElement('span');
        fam.className = 'dii-social__fam';
        fam.textContent = rev.customers_text;
        els.social.appendChild(fam);
      }
      els.social.hidden = false;
    }

    function renderBadges() {
      if (!els.badges) return;
      var badges = (cfg.trust_badges || []).slice(0, 3);
      if (!badges.length) return;
      var ICONS = {
        hand: 'M9 11V5a1.5 1.5 0 0 1 3 0v5m0-1V4a1.5 1.5 0 0 1 3 0v6m0-2a1.5 1.5 0 0 1 3 0v6a6 6 0 0 1-6 6h-1.5a5 5 0 0 1-3.6-1.5L4 16a1.6 1.6 0 0 1 2.3-2.2L8 15V6a1.5 1.5 0 0 1 3 0v4',
        gift: 'M20 12v9H4v-9M2 7h20v5H2zM12 22V7M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7zM12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z',
        return: 'M3 12a9 9 0 1 0 3-6.7L3 8m0-5v5h5'
      };
      var iconOrder = ['hand', 'gift', 'return'];
      els.badges.innerHTML = '';
      badges.forEach(function (txt, i) {
        var li = document.createElement('li');
        li.className = 'dii-badge';
        var ic = ICONS[iconOrder[i]] || ICONS.hand;
        li.innerHTML = '<svg class="dii-badge__ic" viewBox="0 0 24 24" aria-hidden="true"><path d="' + ic + '"/></svg>';
        var span = document.createElement('span');
        span.textContent = txt;            // textContent -> kein XSS
        li.appendChild(span);
        els.badges.appendChild(li);
      });
      els.badges.hidden = false;
    }

    function renderPromo() {
      if (!els.promo) return;
      var promo = cfg.promo || {};
      // active=false (kein echter Rabatt verifiziert) -> Banner NICHT zeigen (DE Omnibus/UWG).
      if (!promo.active) return;
      var pct = promo.percent ? ('−' + promo.percent + ' %') : '−20 %';
      if (els.promoTag) els.promoTag.textContent = pct;
      var txt = String(promo.text || '');
      if (promo.ends_at) txt = txt.replace('{ends_at}', promo.ends_at);
      if (!txt) return;
      els.promoText.textContent = txt;   // textContent -> kein XSS
      els.promo.hidden = false;
    }

    function renderUsps() {
      if (!els.usps) return;
      var usps = (cfg.usps || []);
      if (!usps.length) return;
      var ICONS = {
        hand: 'M9 11V5a1.5 1.5 0 0 1 3 0v5m0-1V4a1.5 1.5 0 0 1 3 0v6m0-2a1.5 1.5 0 0 1 3 0v6a6 6 0 0 1-6 6h-1.5a5 5 0 0 1-3.6-1.5L4 16a1.6 1.6 0 0 1 2.3-2.2L8 15V6a1.5 1.5 0 0 1 3 0v4',
        gift: 'M20 12v9H4v-9M2 7h20v5H2zM12 22V7M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7zM12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z',
        ruler:'M4 16L16 4l4 4L8 20zM9 9l2 2M12 6l2 2M6 12l2 2',
        heart:'M12 21s-7.5-4.9-10-9.2C.6 9 1.6 5.5 4.7 4.6c2-.6 3.9.3 5 1.9 1.1-1.6 3-2.5 5-1.9C22.4 5.5 23.4 9 22 11.8 19.5 16.1 12 21 12 21z'
      };
      els.usps.innerHTML = '';
      usps.forEach(function (u) {
        var li = document.createElement('li');
        li.className = 'dii-usp';
        var ic = ICONS[u.icon] || ICONS.hand;
        li.innerHTML = '<svg class="dii-usp__ic" viewBox="0 0 24 24" aria-hidden="true"><path d="' + ic + '"/></svg>';
        var wrap = document.createElement('span');
        wrap.className = 'dii-usp__txtwrap';
        var t = document.createElement('span'); t.className = 'dii-usp__title'; t.textContent = u.title || '';
        var d = document.createElement('span'); d.className = 'dii-usp__desc'; d.textContent = u.text || '';
        wrap.appendChild(t); wrap.appendChild(d);
        li.appendChild(wrap);
        els.usps.appendChild(li);
      });
      els.usps.hidden = false;
    }

    // ===================== Verfuegbarkeit =====================
    function isColorAvailable(c) {
      if (c.dead) return false;
      // Live-Flag direkt aus der dynamischen Farbliste (aus Live-Variante abgeleitet).
      if (typeof c.available === 'boolean') return c.available;
      var v = variantById[String(c.variant_id)];
      return !!(v && v.available);
    }

    function selectColor(variantId, silent) {
      state.colorId = String(variantId);
      if (!silent) { updatePreview(); updatePriceBlock(); updateTotal(); updateProgress(); }
    }

    function currentColor() {
      return allColors.find(function (x) { return String(x.variant_id) === state.colorId; }) || null;
    }

    // STREICHPREIS v3.2 — Basispreis-Block (durchgestrichener compare_at + reduzierter Preis + -X%).
    // EINE Quelle: liest die gewaehlte Live-Farbe. Dynamisch bei jedem Farbwechsel.
    function updatePriceBlock() {
      var el = root.querySelector('[data-dii-priceblock]');
      if (!el) return;
      var c = currentColor();
      if (!c) { el.innerHTML = ''; return; }
      var price = Number(c.price) || 0;
      var cmp = (c.compare_at != null && Number(c.compare_at) > price + 0.005) ? Number(c.compare_at) : null;
      var html = '';
      if (cmp) {
        var pct = Math.round((1 - price / cmp) * 100);
        html =
          '<span class="dii-price__now">' + fmtMoney(price) + '</span>' +
          '<span class="dii-price__was">' + fmtMoney(cmp) + '</span>' +
          (pct > 0 ? '<span class="dii-price__badge">−' + pct + ' %</span>' : '');
      } else {
        html = '<span class="dii-price__now">' + fmtMoney(price) + '</span>';
      }
      el.innerHTML = html;
    }

    // ===================== KERN rendern =====================
    // v3-Reihenfolge: Vorschau (im Liquid) -> Name (Schritt 1) -> Farbe (Schritt 2)
    //                 -> Textfarbe (3) -> Symbol (4) -> Platzierung (5). Enge Kopplung Vorschau<->Eingabe.
    function renderCore() {
      els.core.innerHTML = '';

      var nameGroup = coreGroups.find(function (g) { return g.type === 'text'; });
      var restGroups = coreGroups.filter(function (g) { return g.type !== 'text'; });

      var step = 0;
      // 1) Name (direkt unter Panorama-Vorschau)
      if (nameGroup) { els.core.appendChild(buildCoreBlock(nameGroup, ++step)); }
      // 2) Farbe
      els.core.appendChild(buildColorBlock(++step));
      // 3..n) restliche Kern-Schritte
      restGroups.forEach(function (g) { els.core.appendChild(buildCoreBlock(g, ++step)); });
    }

    function buildCoreBlock(g, n) {
      var block = document.createElement('div');
      block.className = 'dii-block';
      block.dataset.diiStep = String(n);

      var head = document.createElement('div');
      head.className = 'dii-block__head';
      head.innerHTML =
        '<span class="dii-block__num" data-dii-num>' + n + '</span>' +
        '<h3 class="dii-block__label">' + esc(diiPick(g.label)) + '</h3>';
      block.appendChild(head);
      if (g.info_lines && g.info_lines.length) { appendInfo(head, block, g); }

      if (g.type === 'text') {
        block.appendChild(buildTextField(g));
      } else if (g.key === 'textcolor') {
        block.appendChild(buildColorDots(g));
      } else if (g.key === 'symbol') {
        block.appendChild(buildSymbolPills(g));
        block.appendChild(buildSymbolHint());
      } else if (g.key === 'placement') {
        block.appendChild(buildPlacement(g));
      } else if (g.type === 'select') {
        block.appendChild(buildPills(g));
      }

      if (g.help) {
        var help = document.createElement('p');
        help.className = 'dii-block__help';
        help.textContent = diiPick(g.help);
        block.appendChild(help);
      }
      return block;
    }

    function buildColorBlock(n) {
      var block = document.createElement('div');
      block.className = 'dii-block';
      block.dataset.diiStep = 'color';
      block.innerHTML =
        '<div class="dii-block__head">' +
        '<span class="dii-block__num" data-dii-num>' + (n || 2) + '</span>' +
        '<h3 class="dii-block__label">' + esc(diiT('color_heading', 'Gebetsteppich Farbe wählen')) + '</h3></div>';

      // STREICHPREIS-Block (Basispreis der gewaehlten Farbe, prominent).
      var pb = document.createElement('div');
      pb.className = 'dii-price';
      pb.setAttribute('data-dii-priceblock', '');
      pb.setAttribute('aria-live', 'polite');
      block.appendChild(pb);

      var sw = document.createElement('div');
      sw.className = 'dii-swatches';
      allColors.forEach(function (c) {
        var avail = isColorAvailable(c);
        var wrap = document.createElement('div');
        wrap.className = 'dii-swatch-wrap';
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'dii-swatch' + (avail ? '' : ' dii-swatch--dead');
        // v3.2: echte HEX-Farbflaeche (swatch_bg) bevorzugt; fehlt das Mapping (neue Farbe),
        // Fallback = Varianten-Bild, sonst neutrales Grau. NIE ausblenden.
        if (c.swatch_bg && /^#[0-9a-fA-F]{3,8}$/.test(c.swatch_bg)) {
          btn.style.backgroundColor = c.swatch_bg;
        } else if (c.image) {
          btn.style.backgroundImage = "url('" + escUrl(c.image) + "')";
          btn.style.backgroundSize = 'cover';
          btn.style.backgroundPosition = 'center';
        } else {
          btn.style.backgroundColor = '#ddd';
        }
        btn.setAttribute('aria-label', c.label);
        btn.setAttribute('aria-pressed', String(state.colorId === String(c.variant_id)));
        var nameEl = document.createElement('span');
        nameEl.className = 'dii-swatch-name' + (state.colorId === String(c.variant_id) ? ' dii-swatch-name--sel' : '');
        nameEl.textContent = shortColor(c.label);
        if (avail) {
          btn.addEventListener('click', function () {
            sw.querySelectorAll('.dii-swatch').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
            btn.setAttribute('aria-pressed', 'true');
            sw.querySelectorAll('.dii-swatch-name').forEach(function (s) { s.classList.remove('dii-swatch-name--sel'); });
            nameEl.classList.add('dii-swatch-name--sel');
            selectColor(c.variant_id);
          });
        } else {
          btn.disabled = true;
        }
        wrap.appendChild(btn);
        wrap.appendChild(nameEl);
        if (!avail) {
          var so = document.createElement('span');
          so.className = 'dii-swatch-soldout';
          so.textContent = diiT('soldout', 'Bald wieder da');
          wrap.appendChild(so);
        }
        sw.appendChild(wrap);
      });
      block.appendChild(sw);
      return block;
    }

    // Info-Icon (ⓘ) im Block-Kopf -> klappt einen Hinweis-Kasten auf (mobil-tauglich, Klick statt Hover).
    function appendInfo(head, block, g) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'dii-info-btn';
      btn.setAttribute('aria-label', diiPick(g.info_title) || diiT('info_aria', 'Hinweise zur Personalisierung'));
      btn.setAttribute('aria-expanded', 'false');
      btn.innerHTML =
        '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none">' +
        '<circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.6"/>' +
        '<path d="M12 11v5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>' +
        '<circle cx="12" cy="7.7" r="1.15" fill="currentColor"/></svg>';
      head.appendChild(btn);

      var pop = document.createElement('div');
      pop.className = 'dii-info-pop';
      pop.hidden = true;
      var inner = '';
      if (g.info_title) {
        var t = document.createElement('span'); t.textContent = diiPick(g.info_title);
        inner += '<p class="dii-info-pop__t">' + t.innerHTML + '</p>';
      }
      inner += '<ul class="dii-info-pop__list">';
      (g.info_lines || []).forEach(function (ln) {
        var li = document.createElement('span'); li.textContent = diiPick(ln);   // escape (+ Locale-Pick)
        inner += '<li>' + li.innerHTML + '</li>';
      });
      inner += '</ul>';
      pop.innerHTML = inner;
      block.appendChild(pop);

      btn.addEventListener('click', function () {
        var open = pop.hidden;
        pop.hidden = !open;
        btn.setAttribute('aria-expanded', String(open));
      });
    }

    function buildTextField(g) {
      var wrap = document.createElement('div');
      var input = document.createElement('input');
      input.type = 'text';
      input.className = 'dii-field';
      input.maxLength = g.maxlength || 30;
      input.placeholder = diiPick(g.placeholder) || '';
      input.dataset.diiName = '1';
      input.setAttribute('aria-label', diiPick(g.label));
      // Bidi: Name kann lateinisch ODER arabisch sein -> dir=auto erkennt die Schreibrichtung pro Eingabe
      // (CSS ergaenzt unicode-bidi: plaintext). Der Wert bleibt UTF-8 byte-genau (kein Reordering im Wert).
      input.setAttribute('dir', 'auto');
      input.addEventListener('input', function () {
        var val = input.value.trim();
        if (val) {
          state.core[g.key] = { value: input.value, globo_key: g.globo_key, surcharge: g.surcharge || 0, addon_variant: g.addon_variant, one_time: !!g.one_time };
        } else {
          delete state.core[g.key];
        }
        input.classList.remove('is-error');
        counter.textContent = input.value.length + ' / ' + (g.maxlength || 30);
        updatePreviewName(input.value);
        updateTotal(); updateProgress();
      });
      wrap.appendChild(input);
      var counter = document.createElement('span');
      counter.className = 'dii-counter';
      counter.textContent = '0 / ' + (g.maxlength || 30);
      wrap.appendChild(counter);
      // Aufpreis als WERT-Reframing (nicht Strafe)
      if (g.surcharge) {
        var note = document.createElement('p');
        note.className = 'dii-block__help dii-value-note';
        note.innerHTML = '<span class="dii-badge-price">+ ' + fmtNum(g.surcharge) + ' €</span> ';
        note.appendChild(document.createTextNode(diiT('handmade_included', 'Handstickerei inklusive')));
        wrap.appendChild(note);
      }
      wrap.__input = input;
      return wrap;
    }

    // Textfarbe als Farbpunkte (swatch-HEX), nicht Pills.
    function buildColorDots(g) {
      var wrap = document.createElement('div');
      wrap.className = 'dii-dots';
      wrap.setAttribute('role', 'group');
      wrap.setAttribute('aria-label', diiPick(g.label));
      var values = g.values || [];
      values.forEach(function (v, i) {
        var lraw = typeof v === 'string' ? v : v.label;
        var label = diiCanon(lraw);   // Cart-Property-Wert (byte-genau DE)
        var disp = diiPick(lraw);     // Anzeige (Locale)
        var hex = (typeof v === 'object' && v.swatch) ? v.swatch : '#000';
        var item = document.createElement('button');
        item.type = 'button';
        item.className = 'dii-dot';
        var safeHex = /^#[0-9a-fA-F]{3,8}$/.test(hex) ? hex : '#000';
        item.innerHTML =
          '<span class="dii-dot__chip" style="background:' + safeHex + '"></span>' +
          '<span class="dii-dot__lab">' + esc(disp) + '</span>';
        var isDefault = i === 0;
        item.setAttribute('aria-pressed', String(isDefault));
        if (isDefault) {
          state.core[g.key] = { value: label, globo_key: g.globo_key, surcharge: 0, addon_variant: null };
          textColorHex = safeHex;
        }
        item.addEventListener('click', function () {
          wrap.querySelectorAll('.dii-dot').forEach(function (p) { p.setAttribute('aria-pressed', 'false'); });
          item.setAttribute('aria-pressed', 'true');
          state.core[g.key] = { value: label, globo_key: g.globo_key, surcharge: 0, addon_variant: null };
          textColorHex = safeHex;
          applyPreviewNameColor();
          updateProgress();
        });
        wrap.appendChild(item);
      });
      return wrap;
    }

    // Symbol als Pills MIT SVG-Icon (icon_svg_path aus Config).
    function buildSymbolPills(g) {
      var wrap = document.createElement('div');
      wrap.className = 'dii-pills dii-pills--symbol';
      wrap.setAttribute('role', 'group');
      wrap.setAttribute('aria-label', diiPick(g.label));
      var values = g.values || [];
      values.forEach(function (v, i) {
        var lraw = typeof v === 'string' ? v : v.label;
        var label = diiCanon(lraw);   // Cart-Property-Wert (byte-genau DE)
        var disp = diiPick(lraw);     // Anzeige (Locale)
        var sur = (typeof v === 'object' && v.surcharge) ? v.surcharge : 0;
        var addon = (typeof v === 'object') ? v.addon_variant : null;
        var pill = document.createElement('button');
        pill.type = 'button';
        pill.className = 'dii-pill dii-pill--icon';
        var iconHtml = '';
        if (v.icon_svg_path) {
          iconHtml = '<svg class="dii-pill__svg" viewBox="0 0 24 24" aria-hidden="true"><path d="' + escAttr(v.icon_svg_path) + '"/></svg>';
        }
        pill.innerHTML = iconHtml +
          '<span class="dii-pill__txt">' + esc(shortSymbol(disp)) + '</span>' +
          (sur ? '<span class="dii-pill__sur">+' + fmtNum(sur) + ' €</span>' : '');
        var isDefault = i === 0;
        pill.setAttribute('aria-pressed', String(isDefault));
        if (isDefault) {
          state.core[g.key] = { value: label, globo_key: g.globo_key, surcharge: sur, addon_variant: addon };
        }
        pill.addEventListener('click', function () {
          wrap.querySelectorAll('.dii-pill').forEach(function (p) { p.setAttribute('aria-pressed', 'false'); });
          pill.setAttribute('aria-pressed', 'true');
          state.core[g.key] = { value: label, globo_key: g.globo_key, surcharge: sur, addon_variant: addon };
          updatePreviewName(currentNameValue());   // Symbol in die Live-Vorschau spiegeln
          updateTotal(); updateProgress();
        });
        wrap.appendChild(pill);
      });
      return wrap;
    }

    function buildPills(g) {
      var wrap = document.createElement('div');
      wrap.className = 'dii-pills';
      wrap.setAttribute('role', 'group');
      wrap.setAttribute('aria-label', diiPick(g.label));
      var values = g.values || [];
      values.forEach(function (v, i) {
        var lraw = typeof v === 'string' ? v : v.label;
        var label = diiCanon(lraw);   // Cart-Property-Wert (byte-genau DE)
        var disp = diiPick(lraw);     // Anzeige (Locale)
        var sur = (typeof v === 'object' && v.surcharge) ? v.surcharge : 0;
        var addon = (typeof v === 'object') ? v.addon_variant : null;
        var pill = document.createElement('button');
        pill.type = 'button';
        pill.className = 'dii-pill';
        pill.innerHTML = esc(disp) + (sur ? ' <span class="dii-pill__sur">+' + fmtNum(sur) + ' €</span>' : '');
        var isDefault = i === 0;
        pill.setAttribute('aria-pressed', String(isDefault));
        if (isDefault) {
          state.core[g.key] = { value: label, globo_key: g.globo_key, surcharge: sur, addon_variant: addon };
        }
        pill.addEventListener('click', function () {
          wrap.querySelectorAll('.dii-pill').forEach(function (p) { p.setAttribute('aria-pressed', 'false'); });
          pill.setAttribute('aria-pressed', 'true');
          state.core[g.key] = { value: label, globo_key: g.globo_key, surcharge: sur, addon_variant: addon };
          updateTotal(); updateProgress();
        });
        wrap.appendChild(pill);
      });
      return wrap;
    }

    // ===================== ZUBEHÖR rendern =====================
    // Kleiner Hinweis unter der Symbol-Auswahl (verstaendlich machen).
    function buildSymbolHint() {
      var p = document.createElement('p');
      p.className = 'dii-block__help dii-symbol-hint';
      p.textContent = diiT('symbol_hint', 'Das gewählte Symbol wird klein neben deinem Namen gestickt.');
      return p;
    }

    // PLATZIERUNG: zwei echte Vorschau-Bilder (lange Seite = senkrecht, kurze Seite = waagerecht)
    // als auswaehlbare Karten. Property-Wert (value=label) bleibt byte-genau wie Globo (Fulfillment).
    function buildPlacement(g) {
      var wrap = document.createElement('div');
      wrap.className = 'dii-placecards';
      wrap.setAttribute('role', 'group');
      wrap.setAttribute('aria-label', diiPick(g.label));
      var values = g.values || [];
      function activate(idx) {
        var v = values[idx];
        var label = diiCanon(typeof v === 'string' ? v : v.label);  // Cart-Property-Wert (byte-genau DE)
        wrap.querySelectorAll('.dii-placecard').forEach(function (c, i) {
          c.setAttribute('aria-pressed', String(i === idx));
        });
        state.core[g.key] = { value: label, globo_key: g.globo_key, surcharge: 0, addon_variant: null };
      }
      values.forEach(function (v, i) {
        var lraw = typeof v === 'string' ? v : v.label;
        var img = (typeof v === 'object' && v.image) ? v.image : null;
        var cap = (typeof v === 'object' && v.caption) ? diiPick(v.caption) : diiPick(lraw);  // Anzeige (Locale)
        var card = document.createElement('button');
        card.type = 'button';
        card.className = 'dii-placecard';
        card.setAttribute('aria-pressed', String(i === 0));
        var imgHtml = img
          ? '<span class="dii-placecard__img"><img src="' + escUrl(img) + '" alt="' + escAttr(cap) + '" loading="lazy" decoding="async"></span>'
          : '<span class="dii-placecard__img dii-placecard__img--none"></span>';
        card.innerHTML = imgHtml + '<span class="dii-placecard__cap">' + esc(cap) + '</span>';
        card.addEventListener('click', function () { activate(i); updateProgress(); });
        wrap.appendChild(card);
      });
      if (values.length) { activate(0); }
      return wrap;
    }

    // ROBUSTHEIT v3.2: Upsell-Werte auf verfuegbare Add-ons reduzieren.
    // "Kein ..."-Werte (kein/ungueltiges addon_variant) bleiben immer (Property-only).
    function availableValues(g) {
      return (g.values || []).filter(function (v) {
        var av = v.addon_variant;
        if (!av || av === 'None' || av === 'null') return true;   // "Kein ..." immer behalten
        return addonAvailable(av);
      });
    }

    function renderAccessory() {
      if (!accGroups.length) return;
      els.acc.innerHTML = '';
      var rendered = 0;
      accGroups.forEach(function (g) {
        var card = null;
        if (g.type === 'toggle') {
          // Ganzes Upsell-Produkt weg/aus -> Karte sauber ausblenden (kein toter Eintrag).
          if (!addonAvailable(g.addon_variant)) return;
          card = buildToggleCard(g);
        } else if (g.type === 'select') {
          var vals = availableValues(g);
          var realCount = vals.filter(function (v) { return v.addon_variant && v.addon_variant !== 'None' && v.addon_variant !== 'null'; }).length;
          if (realCount === 0) return;          // keine kaufbare Option mehr -> Karte ausblenden
          var gg = Object.assign({}, g, { values: vals });
          card = (g.collapsible) ? buildSelectToggleCard(gg) : buildImageSelectCard(gg);
        }
        if (card) { els.acc.appendChild(card); rendered++; }
      });
      els.accHead.hidden = rendered === 0;
    }

    function accSubtitle(g) { return diiPick(g.subtitle) || ''; }

    function buildToggleCard(g) {
      var card = document.createElement('div');
      card.className = 'dii-acc-card';
      var head = document.createElement('button');
      head.type = 'button';
      head.className = 'dii-acc-head';
      head.setAttribute('aria-pressed', 'false');
      head.innerHTML =
        accThumb(g) +
        '<span class="dii-acc-titlewrap">' +
          '<span class="dii-acc-title">' + esc(accLabel(g)) + '</span>' +
          (accSubtitle(g) ? '<span class="dii-acc-sub">' + esc(accSubtitle(g)) + '</span>' : '') +
        '</span>' +
        '<span class="dii-badge-price">+ ' + fmtNum(g.surcharge) + ' €</span>' +
        '<span class="dii-acc-toggle" aria-hidden="true"></span>';
      card.appendChild(head);

      var body = document.createElement('div');
      body.className = 'dii-acc-body';
      card.appendChild(body);

      // Sub-Optionen — bebildert (Karten) wenn values Objekte mit image; sonst Dropdown.
      var subState = {};
      (g.sub_options || []).forEach(function (so) {
        var sub = document.createElement('div');
        sub.className = 'dii-sub';
        var lab = document.createElement('span');
        lab.className = 'dii-sub__label';
        lab.textContent = diiPick(so.label);
        sub.appendChild(lab);

        // subState[globo_key] = Cart-Property-WERT -> IMMER kanonisch (diiCanon); Anzeige -> diiPick.
        var hasImages = so.values.some(function (val) { return typeof val === 'object' && val.image; });
        if (hasImages) {
          var cards = document.createElement('div');
          cards.className = 'dii-imgcards';
          subState[so.globo_key] = diiCanon(typeof so.values[0] === 'object' ? so.values[0].label : so.values[0]);
          so.values.forEach(function (val, vi) {
            var vlraw = typeof val === 'object' ? val.label : val;
            var vlc = diiCanon(vlraw);   // Property-Wert
            var vld = diiPick(vlraw);    // Anzeige
            var vi_img = typeof val === 'object' ? val.image : null;
            var cb = document.createElement('button');
            cb.type = 'button';
            cb.className = 'dii-imgcard';
            cb.setAttribute('aria-pressed', String(vi === 0));
            cb.innerHTML =
              (vi_img ? '<span class="dii-imgcard__img" style="background-image:url(\'' + escUrl(vi_img) + '\')"></span>' : '') +
              '<span class="dii-imgcard__lab">' + esc(vld) + '</span>';
            cb.addEventListener('click', function () {
              cards.querySelectorAll('.dii-imgcard').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
              cb.setAttribute('aria-pressed', 'true');
              subState[so.globo_key] = vlc;
              if (state.accessory[g.key]) state.accessory[g.key].subs = Object.assign({}, subState);
            });
            cards.appendChild(cb);
          });
          sub.appendChild(cards);
        } else {
          var sel = document.createElement('select');
          sel.className = 'dii-select';
          so.values.forEach(function (val) {
            var vlraw = typeof val === 'object' ? val.label : val;
            var opt = document.createElement('option');
            opt.value = diiCanon(vlraw);        // ausgewaehlter Wert = Property (byte-genau)
            opt.textContent = diiPick(vlraw);   // Anzeige (Locale)
            sel.appendChild(opt);
          });
          subState[so.globo_key] = diiCanon(typeof so.values[0] === 'object' ? so.values[0].label : so.values[0]);
          sel.addEventListener('change', function () {
            subState[so.globo_key] = sel.value;
            if (state.accessory[g.key]) state.accessory[g.key].subs = Object.assign({}, subState);
          });
          sub.appendChild(sel);
        }
        body.appendChild(sub);
      });

      head.addEventListener('click', function () {
        var on = !card.classList.contains('is-on');
        card.classList.toggle('is-on', on);
        card.classList.toggle('is-open', on);
        head.setAttribute('aria-pressed', String(on));
        if (on) {
          state.accessory[g.key] = {
            on: true,
            value: toggleValue(g),
            globo_key: g.globo_key,
            surcharge: g.surcharge,
            addon_variant: g.addon_variant,
            subs: Object.assign({}, subState)
          };
        } else {
          delete state.accessory[g.key];
        }
        updateTotal();
      });
      return card;
    }

    // Globo-exakter Toggle-Property-Wert aus Config (property_value), Fallback 'Ja'.
function toggleValue(g) {
  return String(g.property_value || 'Ja')
    .replace(/\s*\(\s*\+\s*\d+(?:[.,]\d{1,2})?\s*€?\s*\)\s*$/, '')
    .trim();
}
    // Bebilderte Auswahl-Karten (Lataffa / Quran / Parfuem-Varianten) statt Dropdown.
    function buildImageSelectCard(g) {
      var card = document.createElement('div');
      card.className = 'dii-acc-card dii-acc-card--imgsel';
      var head = document.createElement('div');
      head.className = 'dii-acc-head dii-acc-head--static';
      head.innerHTML =
        '<span class="dii-acc-titlewrap">' +
          '<span class="dii-acc-title">' + esc(accLabel(g)) + '</span>' +
          (accSubtitle(g) ? '<span class="dii-acc-sub">' + esc(accSubtitle(g)) + '</span>' : '') +
        '</span>';
      card.appendChild(head);

      var body = document.createElement('div');
      body.className = 'dii-acc-body dii-acc-body--open';
      var grid = document.createElement('div');
      grid.className = 'dii-imgcards dii-imgcards--wide';

      (g.values || []).forEach(function (v, i) {
        var addonRaw = (v.addon_variant && v.addon_variant !== 'None') ? v.addon_variant : '';
        var vCanon = diiCanon(v.label);   // Cart-Property-Wert (byte-genau DE)
        var card2 = document.createElement('button');
        card2.type = 'button';
        card2.className = 'dii-imgcard';
        card2.setAttribute('aria-pressed', String(i === 0));
        var imgHtml = v.image
          ? '<span class="dii-imgcard__img" style="background-image:url(\'' + escUrl(v.image) + '\')"></span>'
          : '<span class="dii-imgcard__img dii-imgcard__img--none">✕</span>';
        card2.innerHTML =
          imgHtml +
          '<span class="dii-imgcard__lab">' + esc(shortQuran(diiPick(v.label))) + '</span>' +
          (v.surcharge ? '<span class="dii-imgcard__sur">+' + fmtNum(v.surcharge) + ' €</span>' : '');
        card2.addEventListener('click', function () {
          grid.querySelectorAll('.dii-imgcard').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
          card2.setAttribute('aria-pressed', 'true');
          if (addonRaw) {
            state.accessory[g.key] = {
              on: true, value: vCanon, globo_key: g.globo_key,
              surcharge: parseFloat(v.surcharge) || 0, addon_variant: addonRaw
            };
          } else {
            // "Kein ..." -> Property mitschicken (Globo tut das auch), aber kein Add-on
            state.accessory[g.key] = { on: false, value: vCanon, globo_key: g.globo_key, surcharge: 0, addon_variant: null, property_only: true };
          }
          updateTotal();
        });
        grid.appendChild(card2);
      });

      // Default = erster Wert ("Kein ...") -> property_only
      var first = g.values && g.values[0];
      if (first) {
        state.accessory[g.key] = { on: false, value: diiCanon(first.label), globo_key: g.globo_key, surcharge: 0, addon_variant: null, property_only: true };
      }
      body.appendChild(grid);
      card.appendChild(body);
      return card;
    }

    // v3: Quran / Lataffa als TOGGLE (an/aus wie Gebetskette/Parfuemoel).
    //  - AUS (default): Property = "Kein ..." (erster Wert, property_only), KEINE Add-on-Zeile.
    //  - AN: bebilderte Auswahl-Karten erscheinen, default = erste ECHTE Option (mit addon_variant).
    function buildSelectToggleCard(g) {
      var values = g.values || [];
      // "Kein ..."-Wert = erster Wert ohne (gueltige) addon_variant; echte Optionen = Rest.
      var noneVal = values.find(function (v) { return !(v.addon_variant && v.addon_variant !== 'None'); }) || values[0];
      var realVals = values.filter(function (v) { return v.addon_variant && v.addon_variant !== 'None'; });
      var from = realVals.reduce(function (m, v) { var s = parseFloat(v.surcharge) || 0; return (m == null || s < m) ? s : m; }, null);

      function setOff() {
        state.accessory[g.key] = { on: false, value: noneVal ? diiCanon(noneVal.label) : 'Kein', globo_key: g.globo_key, surcharge: 0, addon_variant: null, property_only: true };
      }
      setOff(); // Default AUS

      var card = document.createElement('div');
      card.className = 'dii-acc-card';
      var head = document.createElement('button');
      head.type = 'button';
      head.className = 'dii-acc-head';
      head.setAttribute('aria-pressed', 'false');
      head.innerHTML =
        accThumb(g) +
        '<span class="dii-acc-titlewrap">' +
          '<span class="dii-acc-title">' + esc(accLabel(g)) + '</span>' +
          (accSubtitle(g) ? '<span class="dii-acc-sub">' + esc(accSubtitle(g)) + '</span>' : '') +
        '</span>' +
        (from != null ? '<span class="dii-badge-price">ab ' + fmtNum(from) + ' €</span>' : '') +
        '<span class="dii-acc-toggle" aria-hidden="true"></span>';
      card.appendChild(head);

      var body = document.createElement('div');
      body.className = 'dii-acc-body';
      var grid = document.createElement('div');
      grid.className = 'dii-imgcards dii-imgcards--slider';

      // Default-Auswahl bei AN = erste echte Option.
      var selIdx = realVals.length ? 0 : -1;
      realVals.forEach(function (v, i) {
        var vCanon = diiCanon(v.label);   // Cart-Property-Wert (byte-genau DE)
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'dii-imgcard';
        btn.setAttribute('aria-pressed', String(i === selIdx));
        var imgHtml = v.image
          ? '<span class="dii-imgcard__img" style="background-image:url(\'' + escUrl(v.image) + '\')"></span>'
          : '<span class="dii-imgcard__img dii-imgcard__img--none">✕</span>';
        btn.innerHTML =
          imgHtml +
          '<span class="dii-imgcard__lab">' + esc(shortQuran(diiPick(v.label))) + '</span>' +
          (v.surcharge ? '<span class="dii-imgcard__sur">+' + fmtNum(v.surcharge) + ' €</span>' : '');
        btn.addEventListener('click', function () {
          grid.querySelectorAll('.dii-imgcard').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
          btn.setAttribute('aria-pressed', 'true');
          if (card.classList.contains('is-on')) {
            state.accessory[g.key] = { on: true, value: vCanon, globo_key: g.globo_key, surcharge: parseFloat(v.surcharge) || 0, addon_variant: v.addon_variant };
            updateTotal();
          }
        });
        grid.appendChild(btn);
      });
      // v3.9 SLIDER: horizontales Karussell (groesster Bestand zuerst links). Mobile = Swipe,
      // Desktop = Pfeile. Grid bleibt der Karten-Container (Auswahl-/State-Logik unveraendert).
      var slider = document.createElement('div');
      slider.className = 'dii-slider';
      var arrPrev = document.createElement('button');
      arrPrev.type = 'button';
      arrPrev.className = 'dii-slider__arrow dii-slider__arrow--prev';
      arrPrev.setAttribute('aria-label', diiT('slider_prev', 'Zurück'));
      arrPrev.textContent = '‹';
      var arrNext = document.createElement('button');
      arrNext.type = 'button';
      arrNext.className = 'dii-slider__arrow dii-slider__arrow--next';
      arrNext.setAttribute('aria-label', diiT('slider_next', 'Weiter'));
      arrNext.textContent = '›';
      function diiSlide(dir) {
        var c0 = grid.querySelector('.dii-imgcard');
        var step = c0 ? (c0.getBoundingClientRect().width + 8) : 110;
        var rtlFactor = DII_RTL ? -1 : 1;
        grid.scrollBy({ left: rtlFactor * dir * step * 1.5, behavior: 'smooth' });
      }
      arrPrev.addEventListener('click', function (e) { e.stopPropagation(); diiSlide(-1); });
      arrNext.addEventListener('click', function (e) { e.stopPropagation(); diiSlide(1); });
      slider.appendChild(arrPrev);
      slider.appendChild(grid);
      slider.appendChild(arrNext);
      body.appendChild(slider);
      card.appendChild(body);

      function selectDefaultReal() {
        var v = realVals[selIdx];
        if (!v) return;
        state.accessory[g.key] = { on: true, value: diiCanon(v.label), globo_key: g.globo_key, surcharge: parseFloat(v.surcharge) || 0, addon_variant: v.addon_variant };
      }

      head.addEventListener('click', function () {
        var on = !card.classList.contains('is-on');
        card.classList.toggle('is-on', on);
        card.classList.toggle('is-open', on);
        head.setAttribute('aria-pressed', String(on));
        if (on) {
          // sicherstellen, dass die default-echte Karte markiert ist
          var cards = grid.querySelectorAll('.dii-imgcard');
          cards.forEach(function (x, i) { x.setAttribute('aria-pressed', String(i === selIdx)); });
          selectDefaultReal();
        } else {
          setOff();
        }
        updateTotal();
      });
      return card;
    }

    function accLabel(g) { return diiPick(g.display_label) || diiPick(g.label); }

    // Zubehoer-Thumbnail: echtes <img> fuer http(s)-Bilder (zuverlaessig sichtbar; eine
    // frueher genutzte data-URI als CSS-background griff NICHT). image_icon -> inline-SVG-Icon
    // (DSGVO: kein externer Request, rendert garantiert). Sonst inline-SVG-Fallback ("Geschenk").
    // ACC_ICONS = Modul-Konstante (oben definiert) — NICHT als var hier, sonst undefined bei
    // frueher init-Render-Reihenfolge (var-Assignment-Hoisting-Falle).
    function accThumb(g) {
      var url = g.image;
      if (url && /^https?:\/\//i.test(url)) {
        return '<span class="dii-acc-thumb"><img class="dii-acc-thumb__img" src="' + escUrl(url) +
               '" alt="" loading="lazy" decoding="async"></span>';
      }
      var key = g.image_icon || (g.key === 'bow' ? 'bow' : 'gift');
      var paths = ACC_ICONS[key] || ACC_ICONS.gift;
      return '<span class="dii-acc-thumb dii-acc-thumb--icon">' +
             '<svg viewBox="0 0 48 48" aria-hidden="true" fill="none" stroke-linecap="round">' + paths + '</svg></span>';
    }

    // ===================== Preis / Preview / Progress =====================
    function basePrice() {
      var v = variantById[state.colorId];
      return v ? Number(v.price) / 100 : 0;
    }

    function computeTotal() {
      var sum = basePrice();
      Object.keys(state.core).forEach(function (k) { sum += Number(state.core[k].surcharge || 0); });
      Object.keys(state.accessory).forEach(function (k) {
        var a = state.accessory[k];
        if (a.on || (a.addon_variant)) sum += Number(a.surcharge || 0);
      });
      return sum;
    }

    // Aufpreis-Summe (ohne Basispreis) — fuer den Streich-Gesamtvergleich.
    function surchargeSum() {
      var sum = 0;
      Object.keys(state.core).forEach(function (k) { sum += Number(state.core[k].surcharge || 0); });
      Object.keys(state.accessory).forEach(function (k) {
        var a = state.accessory[k];
        if (a.on || a.addon_variant) sum += Number(a.surcharge || 0);
      });
      return sum;
    }

    function updateTotal() {
      var t = computeTotal();
      els.total.textContent = fmtMoney(t);
      els.total.classList.remove('is-flash');
      void els.total.offsetWidth;
      els.total.classList.add('is-flash');
      // STREICHPREIS in der Sticky-Leiste: Gesamt-Vergleich = compare_at(Farbe) + Aufpreise.
      var was = root.querySelector('[data-dii-total-was]');
      if (was) {
        var c = currentColor();
        var price = c ? Number(c.price) || 0 : 0;
        var cmp = (c && c.compare_at != null && Number(c.compare_at) > price + 0.005) ? Number(c.compare_at) : null;
        if (cmp) {
          was.textContent = fmtMoney(cmp + surchargeSum());
          was.hidden = false;
        } else {
          was.hidden = true;
        }
      }
      if (els.summary && !els.summary.hidden) renderSummary();
    }

    function updatePreview() {
      // v3.1: Vorschau-HINTERGRUND = gewaehlte Teppich-Farbe (swatch_bg), KEIN Foto mehr.
      // Die CSS-Schicht (Verlauf/innerer Schatten/feine Textur) gibt eine dezente Teppich-Anmutung,
      // die Farbe dominiert klar und wechselt sofort bei Farbwahl (Cross-Fade via .is-fading).
      var c = allColors.find(function (x) { return String(x.variant_id) === state.colorId; });
      var hex = (c && c.swatch_bg && /^#[0-9a-fA-F]{3,8}$/.test(c.swatch_bg)) ? c.swatch_bg : bgColorHex;
      if (hex === bgColorHex && els.previewWrap && els.previewWrap.dataset.diiBg) return;
      bgColorHex = hex;
      if (!els.previewWrap) return;
      // Sanfter Cross-Fade der Farbflaeche
      els.previewWrap.classList.add('is-fading');
      var apply = function () {
        els.previewWrap.style.setProperty('--dii-rug-color', hex);
        els.previewWrap.dataset.diiBg = hex;
        els.previewWrap.classList.remove('is-fading');
        // Halo des Namens neu berechnen (haengt von Hintergrund-Helligkeit ab)
        applyPreviewNameColor();
      };
      // prefers-reduced-motion: sofort setzen, sonst kurzer Cross-Fade
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        apply();
      } else {
        window.requestAnimationFrame(function () { window.setTimeout(apply, 90); });
      }
      // preview_image bleibt als Fallback im DOM (img leer), wird aber NICHT mehr als BG genutzt.
      if (els.preview) els.preview.alt = '';
    }

    // Aktueller Name aus dem Eingabefeld (fuer Symbol-Updates ohne Input-Event).
    function currentNameValue() {
      var i = root.querySelector('[data-dii-name]');
      return i ? i.value : '';
    }
    // SVG des gewaehlten Symbols (Herz/Stern/Halbmond) — leer bei "Ohne Symbol" (icon_svg_path null).
    function symbolSvgForPreview() {
      var s = state.core['symbol'];
      if (!s) return '';
      var symGroup = coreGroups.find(function (g) { return g.key === 'symbol'; });
      if (!symGroup) return '';
      var val = (symGroup.values || []).find(function (v) { return diiCanon(typeof v === 'object' ? v.label : v) === s.value; });
      if (!val || !val.icon_svg_path) return '';
      return '<svg class="dii-preview__sym" viewBox="0 0 24 24" aria-hidden="true"><path d="' + escAttr(val.icon_svg_path) + '"/></svg>';
    }

    function updatePreviewName(name) {
      if (!els.previewName) return;
      var v = (name || '').trim();
      var sym = symbolSvgForPreview();
      // Name (escaped) + ggf. Symbol-SVG (Pfaddaten via escAttr gesaeubert) -> kein XSS.
      els.previewName.innerHTML = esc(v) + (v && sym ? '<span class="dii-preview__symsp"></span>' : '') + sym;
      applyPreviewNameColor();
      var hasContent = !!(v || sym);
      if (hasContent) {
        els.previewName.classList.remove('is-empty');
        els.previewName.classList.remove('is-pop'); void els.previewName.offsetWidth;
        els.previewName.classList.add('is-pop');
        if (els.previewHint) els.previewHint.hidden = true;
        if (els.previewCap) els.previewCap.textContent = (v && sym)
          ? diiT('caption_name_symbol', 'So werden Name & Symbol gestickt')
          : (sym ? diiT('caption_symbol', 'So wird dein Symbol gestickt') : diiT('caption_name', 'So wird dein Name gestickt'));
      } else {
        els.previewName.classList.add('is-empty');
        if (els.previewHint) els.previewHint.hidden = false;
        if (els.previewCap) els.previewCap.textContent = diiT('caption_name', 'So wird dein Name gestickt');
      }
    }

    // Relative Luminanz (WCAG) eines #hex -> 0..1
    function luminance(hex) {
      var h = String(hex || '').replace('#', '');
      if (h.length === 3) h = h.replace(/(.)/g, '$1$1');
      if (h.length < 6) return 0.5;
      var r = parseInt(h.slice(0, 2), 16) / 255;
      var g = parseInt(h.slice(2, 4), 16) / 255;
      var b = parseInt(h.slice(4, 6), 16) / 255;
      function lin(v) { return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4); }
      return 0.2126 * lin(r) + 0.7152 * lin(g) + 0.0722 * lin(b);
    }

    // Name in Stickfarbe + Lesbarkeits-Halo. Der Halo nimmt die GEGENFARBE zum
    // Hintergrund (heller Teppich -> dunkler Halo, dunkler Teppich -> heller Halo),
    // damit der Name auf JEDER Kombination Teppich x Stickfarbe abhebt — dezent, nicht kitschig.
    function applyPreviewNameColor() {
      if (!els.previewName) return;
      els.previewName.style.color = textColorHex;
      var bgLum = luminance(bgColorHex);
      // Gegenfarbe zum Untergrund fuer den feinen Halo + weichen Schatten.
      var dark = 'rgba(0,0,0,';
      var light = 'rgba(255,255,255,';
      var haloBase, shadowBase;
      if (bgLum < 0.5) {           // dunkler Teppich -> heller Halo, weicher dunkler Schatten fuer Tiefe
        haloBase = light;
        shadowBase = dark;
      } else {                     // heller Teppich -> dunkler Halo
        haloBase = dark;
        shadowBase = light;
      }
      // 1px gegenfarbiger Halo (4 Richtungen) + weicher Schatten. Bewusst dezent.
      var halo =
        '0 0 1px ' + haloBase + '.85),' +
        ' 1px 0 1px ' + haloBase + '.55),' +
        ' -1px 0 1px ' + haloBase + '.55),' +
        ' 0 1px 1px ' + haloBase + '.55),' +
        ' 0 -1px 1px ' + haloBase + '.55),' +
        ' 0 2px 5px ' + shadowBase + '.30)';
      els.previewName.style.textShadow = halo;
    }

    function updateProgress() {
      var doneSteps = 0;
      if (state.colorId) doneSteps++;
      coreGroups.forEach(function (g) {
        if (g.type === 'text') { if (state.core[g.key]) doneSteps++; }
        else if (state.core[g.key]) doneSteps++;
      });
      var total = 1 + coreGroups.length; // Farbe + Kern
      var pct = Math.min(100, Math.round((doneSteps / total) * 100));
      if (els.progressBar) els.progressBar.style.width = pct + '%';
      if (els.progressLabel) {
        els.progressLabel.textContent = doneSteps >= total
          ? diiT('progress_done', 'Fertig — bereit für den Warenkorb')
          : diiTf('progress_step', 'Schritt {step} von {total}', { step: Math.min(doneSteps + 1, total), total: total });
      }
    }

    // ===================== CART-PAYLOAD (Globo-kompatibel — UNVERAENDERT v1) =====================
    function buildCartPayload() {
      var GID = String(Date.now());
      var items = [];

      var props = {};
      coreGroups.forEach(function (g) {
        var s = state.core[g.key];
        if (!s) return;
        if (g.type === 'text') {
          if (s.value && s.value.trim()) props[g.globo_key] = s.value;
        } else {
          props[g.globo_key] = s.value;
        }
      });
      accGroups.forEach(function (g) {
        var a = state.accessory[g.key];
        if (!a) return;
        if (g.type === 'toggle') {
          if (a.on) {
            props[g.globo_key] = a.value;
            (g.sub_options || []).forEach(function (so) {
              if (a.subs && a.subs[so.globo_key]) props[so.globo_key] = a.subs[so.globo_key];
            });
          }
        } else { // select
          props[g.globo_key] = a.value;
        }
      });
      props['_has_gpo'] = HAS_GPO;
      props['_gpo_product_group'] = GID;

      items.push({ id: String(state.colorId), quantity: state.qty, properties: props });

      function addAddon(addonVariant, fieldName, oneTime) {
        if (!addonVariant || addonVariant === 'None' || addonVariant === 'null') return;
        var p = { '_gpo_parent_product_group': GID, '_gpo_field_name': fieldName };
        if (oneTime) p['_gpo_one_time_charge'] = '1';
        items.push({ id: String(addonVariant), quantity: 1, properties: p });
      }

      var nameG = coreGroups.find(function (g) { return g.type === 'text'; });
      if (nameG) {
        var ns = state.core[nameG.key];
        if (ns && ns.value && ns.value.trim()) addAddon(NAME_ADDON, nameG.globo_key, true);
      }
      // Symbol — IMMER Add-on-Zeile, auch fuer "Ohne Symbol fortfahren" (verifiziert an Orders).
      var symG = coreGroups.find(function (g) { return g.key === 'symbol'; });
      if (symG) {
        var ss = state.core[symG.key];
        if (ss && ss.addon_variant) {
          addAddon(ss.addon_variant, symG.globo_key, false);
        }
      }
      accGroups.forEach(function (g) {
        var a = state.accessory[g.key];
        if (!a) return;
        if (g.type === 'toggle') {
          if (a.on && a.addon_variant) addAddon(a.addon_variant, g.globo_key, !!g.one_time);
        } else { // select Lataffa/Quran
          if (a.addon_variant) addAddon(a.addon_variant, g.globo_key, false);
        }
      });

      return { items: items, gid: GID };
    }

    // ===================== ADD TO CART =====================
    function onAddToCart() {
      var nameG = coreGroups.find(function (g) { return g.type === 'text'; });
      var nameInput = root.querySelector('[data-dii-name]');
      var hasName = nameInput && nameInput.value.trim();
      if (nameG && !hasName) {
        if (!root.__nameWarned) {
          root.__nameWarned = true;
          showInlineWarn(nameInput, diiT('name_warn', 'Magst du noch deinen Namen eintragen? Sonst sticken wir ohne Text.'));
          nameInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
          nameInput.focus();
          return;
        }
      }

      var payload = buildCartPayload();
      els.atc.classList.add('is-loading');
      els.atc.disabled = true;
      els.atcLabel.textContent = diiT('atc_loading', 'Wird hinzugefügt …');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: payload.items, sections: 'cart-icon-bubble', sections_url: window.location.pathname })
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (j) { throw j; });
        return r.json();
      }).then(function (res) {
        // v3.7: Header-Warenkorbzaehler sofort aktualisieren (Theme-Section #cart-icon-bubble + Drawer-Refresh)
        try {
          if (res && res.sections && res.sections['cart-icon-bubble']) {
            var bubble = document.getElementById('cart-icon-bubble');
            if (bubble) bubble.innerHTML = res.sections['cart-icon-bubble'];
          }
          document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
        } catch (e) {}
        els.atcLabel.textContent = diiT('atc_success', 'Im Warenkorb ✓');
        showAddedSheet();
      }).catch(function (err) {
        console.error('[dii-config] cart add fail', err);
        toast((err && err.description) || diiT('error_generic', 'Etwas ist schiefgelaufen — bitte erneut versuchen.'));
        els.atc.classList.remove('is-loading');
        els.atc.disabled = false;
        els.atcLabel.textContent = diiT('atc_default', 'In den Warenkorb');
      });
    }

    // Nach dem Hinzufuegen: Erfolgs-Sheet mit Wahl "Noch einen gestalten" (In-Place-Reset,
    // Warenkorb bleibt) ODER "Zum Warenkorb". Ersetzt das harte Redirect -> Mehrfach-Kauf moeglich.
    function showAddedSheet() {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var rugs = (cart.items || []).filter(function (it) { return it.properties && it.properties._has_gpo; }).length;
          var total = fmtMoney((cart.total_price || 0) / 100);
          var sub = (rugs >= 1 ? diiTf('added_rugs', '{n}× Gebetsteppich im Warenkorb', { n: rugs }) : diiT('added_in_cart', 'Im Warenkorb')) + ' · ' + total;
          var addedTitle = diiT('added_title', 'Zum Warenkorb hinzugefügt');
          var sheet = document.createElement('div');
          sheet.className = 'dii-added';
          sheet.innerHTML =
            '<div class="dii-added__panel" role="dialog" aria-modal="true" aria-label="' + escAttr(addedTitle) + '">' +
              '<button type="button" class="dii-added__x" aria-label="' + escAttr(diiT('close', 'Schließen')) + '">&times;</button>' +
              '<span class="dii-added__check"><svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"/></svg></span>' +
              '<p class="dii-added__t">' + esc(addedTitle) + '</p>' +
              '<p class="dii-added__sub"></p>' +
              '<button type="button" class="dii-btn dii-btn--ghost dii-added__again" data-dii-again>' + esc(diiT('added_again', 'Noch einen gestalten')) + '</button>' +
              '<a class="dii-btn dii-btn--primary dii-added__cart" href="/cart">' + esc(diiT('to_cart', 'Zum Warenkorb')) + '</a>' +
            '</div>';
          sheet.querySelector('.dii-added__sub').textContent = sub;
          document.body.appendChild(sheet);
          requestAnimationFrame(function () { sheet.classList.add('is-show'); });
          var autoT = setTimeout(function () { close(); }, 6000); // v3.7: auto-dismiss nach 6s
          function close() { clearTimeout(autoT); sheet.classList.remove('is-show'); setTimeout(function () { if (sheet.parentNode) sheet.remove(); }, 320); }
          function again() { close(); resetConfigurator(); }
          sheet.querySelector('.dii-added__x').addEventListener('click', again);
          sheet.querySelector('[data-dii-again]').addEventListener('click', again);
          sheet.addEventListener('click', function (e) { if (e.target === sheet) again(); });
          document.addEventListener('keydown', function esc(e) { if (e.key === 'Escape') { again(); document.removeEventListener('keydown', esc); } });
        })
        .catch(function () { window.location.href = '/cart'; });
    }

    // Setzt den Konfigurator fuer eine weitere Bestellung zurueck (Warenkorb bleibt serverseitig).
    function resetConfigurator() {
      state.core = {};
      state.accessory = {};
      state.qty = 1;
      root.__nameWarned = false;
      var first = allColors.find(function (c) { return isColorAvailable(c); });
      if (first) selectColor(first.variant_id, true);
      renderCore();
      renderAccessory();
      updatePreviewName('');
      updatePreview();
      updatePriceBlock();
      updateTotal();
      updateProgress();
      if (els.summary) { els.summary.hidden = true; if (els.peek) els.peek.setAttribute('aria-expanded', 'false'); }
      els.atc.classList.remove('is-loading');
      els.atc.disabled = false;
      els.atcLabel.textContent = diiT('atc_default', 'In den Warenkorb');
      var nameInput = root.querySelector('[data-dii-name]');
      if (nameInput) nameInput.value = '';
      try { root.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e) {}
    }

    // ===================== Helpers =====================
    function showInlineWarn(input, msg) {
      if (!input) return;
      input.classList.add('is-error');
      var existing = input.parentNode.querySelector('.dii-inline-warn');
      if (!existing) {
        var w = document.createElement('p');
        w.className = 'dii-inline-warn';
        w.textContent = msg;
        input.parentNode.appendChild(w);
      }
    }
    function toast(msg) {
      var t = document.createElement('div');
      t.className = 'dii-toast';
      t.textContent = msg;
      document.body.appendChild(t);
      requestAnimationFrame(function () { t.classList.add('is-show'); });
      setTimeout(function () { t.classList.remove('is-show'); setTimeout(function () { t.remove(); }, 300); }, 3200);
    }
    function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
    function escAttr(s) { return String(s == null ? '' : s).replace(/["'<>]/g, ''); } // SVG-Path: nur Pfaddaten
    function escUrl(s) { return String(s == null ? '' : s).replace(/["'()\\]/g, ''); }
    function fmtNum(n) { return Number(n).toFixed(2).replace('.', ','); }
    function fmtMoney(n) { return fmtNum(n) + ' €'; }
    function shortColor(label) { return label.replace(/\s*\(.*?\)\s*/g, '').trim(); }
    function shortSymbol(label) { return label.replace(/\s*fortfahren\s*/i, '').replace(/Ohne Symbol/i, 'Ohne'); }
    function shortQuran(label) {
      // Lange Quran-/Lataffa-Labels fuer Karten kuerzen, ohne Bedeutung zu verlieren.
      return label
        .replace(/^Quran Arabisch - Deutsch Muhamad Rassoul 17x25cm l\s*/i, 'Rassoul 17×25 ')
        .replace(/^Quran arabisch \(Samt, klein\) l\s*/i, 'Samt 13×17 ')
        .replace(/Raumspray$/i, 'Raumspray')
        .trim();
    }

    // Debug-Hook fuer QA (kein Checkout)
    root.__diiBuildPayload = buildCartPayload;
    root.__diiState = state;
  }
})();
